import React, { FunctionComponent } from 'react';

import LoaderIcon from '../Loader/Loader';

import { Container } from './styles';

interface ComponentList {
  name: string;
  attr?: Array<string>;
  heading: string;
}

const InfinityScroll: FunctionComponent<{
  componentList: Array<ComponentList>;
  componentData: Array<any>;
  loading: boolean;
}> = ({ componentList, componentData, loading }) => {
  return (
    <Container>
      <div className="data-row data-header flex bg-common">
        {componentList
          .map((data) => data.heading)
          .filter((heading) => heading)
          .map((heading) => (
            <div className="data-column medium" key={heading}>
              <p>{heading}</p>
            </div>
          ))}
      </div>
      <div className="data-content">
        {!loading ? (
          <div className="text-center larger">
            <LoaderIcon />
          </div>
        ) : componentData && componentData.length ? (
          componentData.map((vehicle, index) => (
            <div key={index} className="data-row flex falign-s mb5 bg-white">
              {componentList.map((field: ComponentList, index: number) => {
                const { name: Component, attr } = field;
                const vehicleObj: any = vehicle;
                const propObj: any = {};
                attr &&
                  attr.forEach((attribute: string) => {
                    propObj[attribute] = vehicleObj[attribute];
                  });

                return <Component key={index} {...propObj} />;
              })}
            </div>
          ))
        ) : (
          <p className="text-center larger p30 bg-white">No Data Found</p>
        )}
      </div>
    </Container>
  );
};

export default InfinityScroll;
